import * as SpinnerActions from './spinner.actions';

// This is the redux sub-store 'spinner' defined by the interface State and its reducer functions

/**
 * The interface defining the redux sub-store
 */
export interface State {
  loading: boolean;
}

/**
 * The reducer acts on actions as defined below, and is the only way to update state
 * The JS spread operator for objects ('...') is used to update a given property of our state
 * while leaving the remaining properties of the state unchanged
 *
 * @param {State} state: the initial state of the redux sub-store
 * @param {DetailPageAction} action: the actions that this sub-store is managing
 * @returns {State} updated state of the redux sub-store
 */
export function spinnerReducer(state: State = {
  loading: false
},
action: SpinnerActions.SpinnerAction): State {
  switch (action.type) {
  case SpinnerActions.UPDATE_LOADING:
    return {
      ...state,
      loading: action.payload
    };
  default:
    return state;
  }
}



